import { AppConfig } from "@pershing/shell-comms";

export interface PortalWindow extends Window {
  GUIDE_ME: { PROJECT_ID: string; USER_IDENTIFIER: string };
  ASSETS_BASE_URL: string;
  selection: string;
  appSelection: string;
  partnerHouseholdId: string;
  userType: string;
  target: string;
  pershingAppSettings: object | string;
  pxNao: unknown;
  appConfig: AppConfig;
}

export const portalWindow: PortalWindow = window as unknown as PortalWindow;
